export function isSelectableSubscription(status: string | null | undefined): boolean {
  return status == null || status === 'ACTIVE';
}
